"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogDropdownTrigger = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIcons = require("@100mslive/react-icons");
var _reactUi = require("@100mslive/react-ui");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var DialogDropdownTrigger = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var title = _ref.title,
    css = _ref.css,
    open = _ref.open,
    icon = _ref.icon,
    _ref$titleCSS = _ref.titleCSS,
    titleCSS = _ref$titleCSS === void 0 ? {} : _ref$titleCSS;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dropdown.Trigger, {
    asChild: true,
    "data-testid": "".concat(title, "_selector"),
    css: _objectSpread({
      border: "1px solid $borderLight",
      bg: "$surfaceLight",
      r: "$1",
      p: "$6 $9",
      zIndex: 10
    }, css),
    ref: ref,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
      css: {
        display: "flex",
        justifyContent: "space-between",
        color: "$textHighEmp",
        w: "100%"
      },
      children: [icon, /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
        css: _objectSpread(_objectSpread({
          color: "inherit"
        }, (0, _reactUi.textEllipsis)("90%")), {}, {
          flex: "1 1 0",
          mx: "$6"
        }, titleCSS),
        children: title
      }), open ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.ChevronUpIcon, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.ChevronDownIcon, {})]
    })
  });
});
exports.DialogDropdownTrigger = DialogDropdownTrigger;